import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as LockIcon } from '../../assets/images/svg/lock.svg';
import themeColors from '../../assets/styles/themeColors';

const LockIconStyled = styled(LockIcon)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  stroke: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const Lock = (props) => <LockIconStyled {...props} />;

Lock.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

Lock.defaultProps = {
  w: '24px',
  h: '24px',
};

export default Lock;
